export const mediaTag = {
  headers: [
    {
      sortable: true,
      value: 'name',
      type: 'button',
      display: 'name',
    },
    {
      sortable: true,
      display: 'medias',
      value: 'medias',
    },
    {
      sortable: true,
      display: 'updatedAt',
      type: 'date',
      value: 'updatedAt',
    },
    {
      sortable: true,
      display: 'active',
      type: 'checkbox',
      value: 'is_deactivated',
    },
  ],
};

export const medicalCondition = {
  headers: [
    {
      sortable: true,
      value: 'name',
      type: 'button',
      display: 'name',
    },
    {
      sortable: true,
      display: 'users',
      value: 'users',
    },
    {
      sortable: true,
      display: 'updatedAt',
      type: 'date',
      value: 'updatedAt',
    },
    {
      sortable: true,
      display: 'active',
      type: 'checkbox',
      value: 'is_deactivated',
    },
  ],
};

export const scalpCondition = {
  headers: [
    {
      sortable: true,
      value: 'name',
      type: 'button',
      display: 'name',
    },
    {
      sortable: true,
      display: 'users',
      value: 'users',
    },
    {
      sortable: true,
      display: 'updatedAt',
      type: 'date',
      value: 'updatedAt',
    },
    {
      sortable: true,
      display: 'active',
      type: 'checkbox',
      value: 'is_deactivated',
    },
  ],
};

export const shop = {
  headers: [
    {
      sortable: true,
      isLink: true,
      linkName: 'editShop',
      value: 'name',
      display: 'name',
      width: '400',
    },
    {
      sortable: true,
      value: 'users',
      display: 'users',
      width: '100',
    },
    {
      sortable: true,
      value: 'address',
      display: 'address',
    },
    {
      sortable: true,
      value: 'country',
      display: 'country',
    },
    {
      sortable: false,
      value: '',
      display: '',
      width: '48',
    },
  ],
};

export const point = {
  headers: [
    {
      display: 's3_location',
      isImg: true,
      width: '48',
      sortable: false,
    },
    {
      sortable: false,
      value: 'name',
      display: 'name',
    },
    {
      sortable: false,
      value: 'points',
      display: 'points',
    },
    {
      sortable: false,
      value: 'description',
      display: 'description',
    },
    {
      sortable: true,
      display: 'createdAt',
      type: 'date',
      value: 'createdAt',
    },
  ],
};

export const user = {
  headers: [
    {
      sortable: true,
      isLink: true,
      linkName: 'editUserMedia',
      display: 'full_name',
      value: 'full_name',
      width: '300',
    },
    {
      sortable: true,
      display: 'points',
      value: 'points',
    },
    {
      sortable: true,
      isNested: true,
      display: 'shop',
      value: 'shop_id',
    },
    {
      sortable: true,
      display: 'mobile',
      value: 'mobile',
    },
    {
      sortable: true,
      display: 'medias',
      value: 'medias',
    },
    {
      sortable: true,
      display: 'updatedAt',
      type: 'date',
      value: 'updatedAt',
    },
    {
      sortable: false,
      display: '',
      value: '',
      width: '48',
    },
  ],
};

export const redeemable = {
  headers: [
    {
      display: 's3_location',
      isImg: true,
      width: '48',
      sortable: false,
    },
    {
      display: 'name',
      isLink: true,
      linkName: 'editRedeemable',
      sortable: true,
      value: 'name',
      width: '400',
    },
    {
      sortable: true,
      display: 'points',
      value: 'points',
    },
    {
      sortable: false,
      display: 'description',
      value: 'description',
    },
    {
      sortable: true,
      display: 'start',
      value: 'start',
      type: 'date',
      format: 'dd-MM-yyyy',
    },
    {
      sortable: true,
      display: 'end',
      format: 'dd-MM-yyyy',
      type: 'date',
      value: 'end',
    },
    {
      sortable: false,
      display: '',
      value: '',
      width: '48',
    },
  ],
};

export const rewardTemplate = {
  headers: [
    {
      display: 'name',
      isLink: true,
      linkName: 'editRewardTemplate',
      sortable: true,
      value: 'name',
      width: '400',
    },
    {
      sortable: true,
      display: 'points',
      value: 'points',
    },
    {
      sortable: false,
      display: 'description',
      value: 'description',
    },
    {
      sortable: true,
      display: 'start',
      format: 'dd-MM-yyyy',
      type: 'date',
      value: 'start',
    },
    {
      sortable: true,
      display: 'end',
      format: 'dd-MM-yyyy',
      type: 'date',
      value: 'end',
    },
    {
      sortable: false,
      display: '',
      value: '',
      width: '48',
    },
  ],
};
